import { useContext, useState } from 'react';
import { SfFunnelMenuContext } from './SfFunnelMenuProvider';
import { SfFunnelMenu } from './SfFunnelMenu';
import { ConfirmDeleteFunnelDialog } from './ConfirmDeleteFunnelDialog';
import { useRemoveDeleteSfFunnelFromCanvas } from './useRemoveDeleteSfFunnelFromCanvas';

export const ConnectedSfFunnelMenu = () => {
  const { anchorEl, setAnchorEl } = useContext(SfFunnelMenuContext);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const { handleDeleteFunnel, handleRemoveFromCanvas } = useRemoveDeleteSfFunnelFromCanvas();

  if (!anchorEl?.anchorEl) {
    return null;
  }

  return (
    <>
      <SfFunnelMenu
        anchorEl={anchorEl.anchorEl}
        onClose={() => setAnchorEl(null)}
        onClick={(action: 'remove' | 'delete') => {
          if (action === 'remove') {
            handleRemoveFromCanvas(anchorEl.funnelId);
            setAnchorEl(null);
          } else {
            setIsConfirmDeleteOpen(true);
          }
        }}
      />
      <ConfirmDeleteFunnelDialog
        open={isConfirmDeleteOpen}
        onClose={() => setIsConfirmDeleteOpen(false)}
        onConfirm={async () => {
          await handleDeleteFunnel(anchorEl.funnelId);
          setIsConfirmDeleteOpen(false);
          setAnchorEl(null);
        }}
      />
    </>
  );
};
